/**
 * @file Grid base component
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { ControlBase } from '../../base/helpers/control-base';
var GridBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GridBaseComponent, _super);
    /**
     * Creates an instance of GridBaseComponent.
     * @param {DomainService} domainService
     * @param {configurationsService} configurationsService
     */
    function GridBaseComponent(domainService, localStorageService, gridService, alertsService) {
        var _this = _super.call(this, alertsService) || this;
        _this.domainService = domainService;
        _this.localStorageService = localStorageService;
        _this.gridService = gridService;
        /**
         * A value indicating whether AfterViewInit has completed.
         * @memberOf GridDisplayBaseComponent
         */
        _this.initialized = false;
        // Test if current device is a touch device
        _this.deviceAgent = navigator.userAgent.toLowerCase();
        _this.isTouchDevice = ('createTouch' in document || screen.width <= 699 ||
            _this.deviceAgent.includes('iphone') ||
            _this.deviceAgent.includes('ipod') ||
            _this.deviceAgent.includes('ipad') ||
            _this.deviceAgent.includes('blackberry') ||
            _this.deviceAgent.includes('android'));
        // Keep track of the available layers
        _this.availableLayers = [
            { name: 'workpatterns', title: 'APP.GRIDS.LAYER_WORKPATTERNS' },
            { name: 'availabilities', title: 'APP.GRIDS.LAYER_AVAILABILITIES' },
            { name: 'absences', title: 'APP.GRIDS.LAYER_ABSENCES' },
            { name: 'assignments', title: 'APP.GRIDS.LAYER_ASSIGNMENTS' },
            { name: 'appointments', title: 'APP.GRIDS.LAYER_APPOINTMENTS' },
            { name: 'attendants', title: 'APP.GRIDS.LAYER_ATTENDANTS' },
            { name: 'drop-targets', title: 'APP.GRIDS.LAYER_DROPTARGETS' },
            { name: 'violations', title: 'APP.GRIDS.LAYER_VIOLATIONS' },
            { name: 'adhoc', title: 'APP.GRIDS.LAYER_ADHOC' },
            { name: 'template', title: 'APP.GRIDS.LAYER_TEMPLATE' },
            { name: 'forecast', title: 'APP.GRIDS.LAYER_FORECAST' },
            // Tijdelijk, script + extra, uitgezet zonder dat ejs omvalt.
            // Zie: Lagen kiezer lijkt niet helemaal goed te werken bij forecast opties. #3074
            /*
                    { name: 'script', title: 'APP.GRIDS.LAYER_SCRIPT' },
                    { name: 'extra', title: 'APP.GRIDS.LAYER_EXTRA' },
            */
            { name: 'dragsources', title: 'APP.GRIDS.LAYER_DRAGSOURCES' }
        ];
        // Important: visiblity per layer is also per grid type (see agenda-grid and planboard-grid)
        _this.visibilityPerLayer = {};
        /** Event triggered when a entity from the list is selected. */
        _this.selectionChanged = new EventEmitter();
        /**  */
        _this.gridBarSource = undefined;
        _this.pluginPairSource = undefined;
        /**
         * Used as model for the layer select element
         */
        _this._layer = '';
        return _this;
    }
    Object.defineProperty(GridBaseComponent.prototype, "startDate", {
        /**
         * The start date currently displayed in the grid
         * This is taken from the current horizon
         * @readonly
         * @type {moment.Moment}
         */
        get: function () {
            return this.gridService.startDate;
        },
        enumerable: true,
        configurable: true
    });
    GridBaseComponent.prototype.areSettingsOpen = function () {
        return this.gridService.settingsOpen;
    };
    GridBaseComponent.prototype.toggleSettingsOpen = function () {
        this.gridService.settingsOpen = !this.gridService.settingsOpen;
    };
    Object.defineProperty(GridBaseComponent.prototype, "dragsourcesPinned", {
        /**
         * Are the dragsources pinned?
         *
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return this.localStorageService.readProperty('local', 'dragsources-pinned', false, [true, false]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "endDate", {
        /**
         * The end date currently displayed in the grid
         * This is taken from the current horizon
         * @readonly
         * @type {moment.Moment}
         */
        get: function () {
            return this.gridService.endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "layer", {
        /**
         * Get the layer
         */
        get: function () {
            return this._layer;
        },
        /**
         * Set the layer
         */
        set: function (name) {
            var _this = this;
            // Try to find the layer
            var foundLayer = this.availableLayers.find(function (visibleLayer) {
                return (visibleLayer.name === name);
            });
            // If found toggle the visibility
            if (foundLayer) {
                this.visibilityPerLayer[name] = !this.visibilityPerLayer[name];
                this.localStorageService.updateProperty('local', 'grid-show-' + name, this.visibilityPerLayer[name], [true, false]);
            }
            // Initial set the new value
            this._layer = name;
            // In the next cycle set it back to show the 'placeholder' text
            setTimeout(function () {
                _this._layer = '';
            }, 1);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets a value indicating that the view is initialized
     * @memberOf GridBaseComponent
     */
    GridBaseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.initialized = true;
        });
    };
    /**
     * Count the number of visible layers
     */
    GridBaseComponent.prototype.countVisibleLayers = function () {
        var _this = this;
        var visibleLayers = Object.keys(this.visibilityPerLayer).filter(function (key) {
            return (_this.visibilityPerLayer[key] === true && _this.availableLayers.find(function (item) { return item.name === key; }));
        });
        return visibleLayers.length;
    };
    /**
     * Are there dragsources?
     * @readonly
     * @type {boolean}
     */
    GridBaseComponent.prototype.hasDragsources = function () {
        return (this.canCreate === true || this.canDelete === true) && this.visibilityPerLayer['dragsources'] === true;
    };
    /**
     * Translate the visibility of given name to the correct localisation key
     */
    GridBaseComponent.prototype.transformVisibilityToLocalisationKey = function (name) {
        return this.visibilityPerLayer[name] === true ? 'APP.GRIDS.LAYER_VISIBLE_YES' : 'APP.GRIDS.LAYER_VISIBLE_NO';
    };
    Object.defineProperty(GridBaseComponent.prototype, "level", {
        /**
         * The detaillevel used for the display
         * This is taken from the current horizon
         * @readonly
         * @type {DetailLevel}
         */
        get: function () {
            return this.gridService.level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "visibleDays", {
        /**
         * Visible days in the grid
         * This is taken from the current horizon
         * @readonly
         * @type {[number]}
         */
        get: function () {
            return this.gridService.visibleDays;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "visibleHoursStart", {
        /**
         * Start hour for the grid
         * This is taken from the current horizon
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleHoursStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "visibleHoursEnd", {
        /**
         * End hour for the grid
         * This is taken from the current horizon
         * @readonly
         * @type {Number}
         */
        get: function () {
            return this.gridService.visibleHoursEnd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "weekends", {
        /**
         * Are weekends enabled
         * This is taken from the current horizon
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return this.gridService.weekends;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridBaseComponent.prototype, "officeHours", {
        /**
         * Are office hours enabled
         * This is taken from the current horizon
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return this.gridService.officeHours;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects an item in the grid
     * @param {Entity} item
     */
    GridBaseComponent.prototype.selectPlanItem = function (item) {
        this.selectionChanged.emit(item);
    };
    return GridBaseComponent;
}(ControlBase));
export { GridBaseComponent };
